import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { RoleManagementService } from '@services/role.management.service';
// import { Editor } from 'ngx-editor';
import { AddNewQuestion, Options, QuestionDescription } from 'src/app/shared/addnewquestion';
import { CkeditorConfig, ScoringTypeEnum, QuestionSubTypeIdEnum, QuestionTypeIdEnum, QuestionTypeEnum } from 'src/app/shared/config/questions.config';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { ItemsSubPartEditorComponent } from '../items-sub-part-editor/items-sub-part-editor.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import { MatSnackBar } from '@angular/material/snack-bar';
import Adapter from '../ckeditorAdapter';
// import { getDataFromElement } from '@ckeditor/ckeditor5-dev-utils';
@Component({
  selector: 'app-items-multiple-choice-multiple-response',
  templateUrl: './items-multiple-choice-multiple-response.component.html',
  styleUrls: ['./items-multiple-choice-multiple-response.component.scss']
})
export class ItemsMultipleChoiceMultipleResponseComponent implements OnInit, OnDestroy {

  listDisplay;
  itemId: any;
  deleteOptionId: any;
  display: boolean = false;
  que: any;
  // editor1: Editor;
  questionDescription: [];
  set_main_form = false;
  addOptionNew: Options[] = [];
  addedOptions: string[] = [];
  newOptionArray = [];
  moreSetting: [];
  opened = false;
  optionDiv = false;
  openedD = false;
  parentData = 1;
  i = 0;
  userForm: FormGroup;
  tabs = [];
  selected = new FormControl(0);
  editorform: FormGroup;
  // editor: Editor;
  // editors: Editor[] = [];
  option: [];
  question: [];
  fetchEditQuetion: any;
  fetchEditOption: any;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');
  panelOpenState: boolean = false;
  animal: string;
  name1: string;
  optionIdDia: any;
  html: string;
  questionhtml: any;
  fetchEditQuetion1: any;
  queId: any;
  seteditor = true;
  autoscoreSelectValue: any;
  allowChwckAnsSelectValue: any;
  scoringTypeExactMatchValue: any;
  questionDisplayValue: string;
  getQuestionDisplay: string;
  shuffleSelectValue: any;
  autoscoring: boolean;
  checkansSelectValue: any;
  checkAnsmaintValue: any;

  miniscoretype: any;
  miniscoretypeMainvalue: any;

  penaltypointselectvalue: any;
  penaltypointMainvalue: any;
  scoringselectvalue: any;
  addnewquestion = new AddNewQuestion();
  addnewquestiondescription = new QuestionDescription();
  setAddOption = true;
  editMode = false;
  ckeditorConfig = CkeditorConfig;
  isCkeditorLoading: boolean = true;
  ScoringTypeEnum = ScoringTypeEnum;
  radioSelected: [];
  checkradiovalue = false;

  getscoringtype: any;
  getAllowCheckAns: any;

  updateOptionText: any;

  submitted = false;

  newArrayforAddOption: any;

  showQuestionError = false;
  saveDataValidation = false;

  checkSelectionOption: any;
  itemBankQueId: any;
  addQuestionScore: any;
  newEvent = 0;
  newEvent1: any;
  scoreArray = [];
  questionscoreF = false;
  arrayForScoreadd: any;
  defultvalueScore = 0;
  defultvalue = 0;
  @Output() postCreated = new EventEmitter();
  @Output() oneMoreBack = new EventEmitter();
  addQuestionForm: FormGroup;
  addOptionForm: FormGroup;
  saveDisable: boolean = false;
  questionuuuid: any;
  addOptions: boolean = true;
  scoringTypeId: any;
  StyleList: any;
  selectedStyle: any;
  QuestionScoringType: any;
  QuestionOrientation: any;
  //-------- CKEditor5 Version---------
  @ViewChild("myEditor") myEditor: any;
  @ViewChild("myEditor1") myEditor1: any;
  public Editor: any = Editor;
  errorMessage;
  errorMessageOption;
  public uploadedFileNames = [];
  public uploadedFileOptions = [];
  QuestionImages = []
  optionImages = []
  imageId: number = 1;
  constructor(
    public roleSer: RoleManagementService,
    private fb: FormBuilder,
    private router: Router,
    private routerstate: ActivatedRoute,
    public dialog: MatDialog,
    public questionService: QuestionService,
    public itemservice: ItemService,
    private notificationService: NotificationService,
    public sanitizer: DomSanitizer,
    private webErrorService: WebErrorService,
    public translate: TranslateService,
    public _snackBar: MatSnackBar
  ) {
    this.itemBankQueId = sessionStorage.getItem('itemId');
    this.scoringTypeId = sessionStorage.getItem('scoringTypeId')
    this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
    });

    if (sessionStorage.getItem('questionuuId')) {
      this.queId = sessionStorage.getItem('questionuuId');
    } else {
      this.queId = this.router.getCurrentNavigation()?.extras?.state?.queId;
    }

    this.userForm = fb.group({
      hideRequired: this.hideRequiredControl,
      floatLabel: this.floatLabelControl,
      autoscore: new FormControl(true),
      shuffle: [''],
      scoringTypeMatch: ['false'],
      questionDisplay: ['Vertical'],
      allowCheckAnswer: ['false'],
      penaltyPoint: [''],
      minimumScoreIfAttempt: [0, Validators.required],
    });

    this.questionService.updateEditText.subscribe((data) => {
      if (this.editMode == true) {
        if (this.fetchEditOption) {
          this.fetchEditOption.forEach((a) => {
            if (a.optionId == data.optionIdDia) {
              a.answerDescription.description = data.newValue;
              a.modified = true;
            }
          });
          this.addOptionNew = this.fetchEditOption;
        }
      } else {
        if (this.addOptionNew) {
          this.newArrayforAddOption = this.addOptionNew;
          this.newArrayforAddOption.forEach((a) => {
            if (a.optionId == data.optionIdDia) {
              a.answerDescription.description = data.newValue;
              a.modified = true;
            }
          });
          this.addOptionNew = this.newArrayforAddOption;
        }
      }
    });

    this.questionService.getQuestionScoringType().subscribe(d => {this.QuestionScoringType = d.data})
    this.questionService.getQuestionOrientation().subscribe(o => {this.QuestionOrientation = o.data})
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onReadyOption(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessageOption = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessageOption = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessageOption = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileOptions.push(res.fileName)
        this.optionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  createOptionControl(): FormGroup {
    return this.fb.group({
      value: [null, Validators.required],
    });
  }


  ngOnInit(): void {
    this.itemservice.StyleListData.subscribe(e => {this.StyleList = e});
    this.saveDisable = false;
    // this.editor = new Editor();
    // this.editor1 = new Editor();
    this.addQuestionForm = new FormGroup({
      question: new FormControl(
        { value: '', disabled: false },
        Validators.required
      )
    });
    this.addOptionForm = new FormGroup({
      option: new FormControl({
        value: '', disabled: false
      },
        Validators.required)
    });
    if (this.queId) {
      this.seteditor = true;
      this.editMode = true;
      this.questionService
        .getQuestion(this.itemId, this.queId)
        .subscribe((resdata) => {
          this.questionuuuid = resdata?.data.questionuuId;
          this.addQuestionForm.controls['question'].setValue(resdata?.data?.questiondescription?.description);
          this.uploadedFileNames = resdata?.data?.questiondescription?.file_name;
          this.fetchEditOption = resdata.data?.options;
          // if (this.scoringTypeId == ScoringTypeEnum.On180360Degree) {
          //   this.fetchEditOption.forEach(element => {
          //     element['selectedStyle'] = [{styleId: element.styleid, styleName: this.StyleList.find(d => d.styleId == element.styleid)?.styleName}];
          //     // this.selectedStyle = [{styleId: element.styleid, styleName: this.StyleList.find(d => d.styleId == element.styleid)?.styleName}]
          //   });
          // }

          this.addOptionNew = this.fetchEditOption;
          this.checkSelectionOption = this.addOptionNew;
          this.newEvent = resdata.data?.correctPoints;
          this.arrayForScoreadd = this.fetchEditOption;
          this.autoscoring = resdata.data?.autoScoring;
          this.userForm.setValue({
            hideRequired: this.hideRequiredControl,
            floatLabel: this.floatLabelControl,
            autoscore: resdata.data.autoScoring,
            shuffle: resdata.data.shuffleOption,
            scoringTypeMatch: resdata.data.scoringTypeExactMatch,
            allowCheckAnswer: resdata.data.allowCheckAnswer,
            questionDisplay: resdata.data.questiondisplayoptions,
            penaltyPoint: resdata.data.penaltyPoint,
            minimumScoreIfAttempt: resdata.data.minScoreIfAttempt,
          });
          this.getscoringtype = String(resdata.data.scoringTypeExactMatch);
          this.getQuestionDisplay = String(resdata.data.questiondisplayoptions);
          this.getAllowCheckAns = String(resdata.data.allowCheckAnswer);
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) ||  k == 46);
  }

  replace2Decimal(event: any, o?: any, type?: any){
    let value = event.target.value;
    if (event.key == '.') value = value + event.key;
    if(value == '.') value = "";
    var ponto = value.split('.').length;

    if (ponto > 2) value = value.substr(0, (value.length)-1);

    value = value.replace(/[^0-9.-]/,'');

    if (ponto == 2) value = value.substr(0,(value.indexOf('.')+3));

    if (type == 'options') o.correctPoints = parseFloat(value);
    if (type == 'minimumScore') {
      let num = value.substr(value.length - 1);
      if (num != '.' && value != '') this.userForm.controls.minimumScoreIfAttempt.setValue(parseFloat(value))
    }
  }

  validateInput(event, o?, type?) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^\d{0,4}(\.\d{0,2})?$/;
    const inputVal = inputElement.value.split('.')
    const beforeDecimal = inputVal[0]
    const afterDecimal = inputVal[1]
    console.log('value',value)
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      if(type == 'options') o.correctPoints = parseFloat(inputElement.value );
      if(type == 'minimumScore') this.userForm.controls.minimumScoreIfAttempt.setValue(parseFloat(inputElement.value))
      if(beforeDecimal.length == 5 && afterDecimal.length > 1){
        inputElement.value = ''
        if(type == 'options') o.correctPoints = 0; 
        if(type == 'minimumScore') this.userForm.controls.minimumScoreIfAttempt.setValue(0)
      }
    }
  }

  get optionrows(): FormArray {
    return <FormArray>this.userForm.get('optionrows');
  }
  get o() {
    return this.addQuestionForm.controls;
  }
  get f() {
    return this.userForm.controls;
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg1'), true, 'warn')
      return false;
    } else {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg1'), true, 'warn')
      return false;
    }
  }

  addOptionRow(): void {
    // this.editors.push(new Editor());
    this.optionrows.push(this.createOptionControl());
  }

  removeOptionRow(index: any) {
    (this.userForm.get('optionrows') as FormArray).removeAt(index);
  }

  getRowFormControls(): AbstractControl[] {
    return (<FormArray>this.userForm.get('DyRow')).controls;
  }

  onCheckRadioOption(o, value) {
    this.checkSelectionOption.forEach((element) => {
      if (
        element.optionId == o.optionId
      ) {
        if (element.answerValid == false) {
          element.answerValid = true;
        } else {
          element.answerValid = false;
        }
        this.addScore(o);
      }
    });
    this.addOptionNew = this.checkSelectionOption;
  }

  addOption() {
    this.questionhtml = this.addQuestionForm.controls['question'].value;

    if (!this.questionhtml || this.questionhtml.length == 0) {
      this.showQuestionError = true;
    } else {
      this.showQuestionError = false;
      this.questionscoreF = true;
      var i = this.addOptionNew.length + 1;
      this.html = this.addOptionForm.controls['option'].value;
      // this.html = this.html.replace(/<img/g, '<img width="100" height="100"');
      let rmcharHtml = this.html //.replace(/(<([^>]+)>)/ig, '');
      let rmCharSpace = rmcharHtml.replace(/&nbsp;/g,'').trim();
      if (this.html != '<p></p>' && rmCharSpace.length !== 0) {
        this.addedOptions.push(rmCharSpace);
        this.addOptionNew.push({
          answerDescription: {
            description: rmCharSpace,
            mediaURL: [''],
            file_name: this.uploadedFileOptions
          },

          answerValid: false,
          arrangeOrder: i,
          correctPoints: 0,
          modified: false,
          optionId: (this.addOptionNew.length) ? this.addOptionNew[this.addOptionNew.length - 1].optionId + 1 : 1,
          selected: false,
          styleid: 0
        });
        this.addOptionNew.forEach((e, index) => {
          e.arrangeOrder = index + 1;
        });
        this.checkSelectionOption = this.addOptionNew;
        this.newArrayforAddOption = this.addedOptions;
        this.addOptions = true;
        this.errorMessageOption = false;
      } else {
        this.addOptions = false;
      }
      this.uploadedFileOptions = [];
      this.addOptionForm.get('option').reset();
      this.arrayForScoreadd = this.addOptionNew;
    }


  }

  addScore(valuescore) {
    this.scoreArray = [];
    this.arrayForScoreadd.forEach((element) => {
      if (element.answerValid == true) {
        this.scoreArray.push(element.correctPoints);
      }
    });
    this.newEvent = this.scoreArray.reduce(add, 0);
    function add(accumulator, a) {
      return accumulator + a;
    }
  }

  onSelectStyle(event, option) {
    if (event.target.value) {
      this.addOptionNew.forEach((element) => {
        if (option === element.optionId) {
          element['styleid'] = parseInt(event.target.value);
        }
      });
    }
  }

  deleteOption(index: any) {
    this.addOptionNew.splice(index, 1);
    this.scoreArray = [];
    this.arrayForScoreadd.forEach((element) => {
      if (element.answerValid == true) {
        this.scoreArray.push(element.correctPoints);
      }
    });
    this.newEvent = this.scoreArray.reduce(add, 0);
    function add(accumulator, a) {
      return accumulator + a;
    }
  }

  deleteEditOption(index: any, deleteOption: any) {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('questions.typeOfQuestions.multipleResponse.deletePopup.message'),
        buttonText: {
          ok: this.translate.instant('questions.typeOfQuestions.multipleResponse.deletePopup.btnYes'),
          cancel: this.translate.instant('questions.typeOfQuestions.multipleResponse.deletePopup.btnNo'),
        },
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        if (this.addOptionNew.length == 2) {
          this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg2'), true, 'warn')
          return;
        }
        this.fetchEditOption.splice(index, 1);
        this.deleteOptionId = deleteOption.id;
        if (this.deleteOptionId) {
          this.questionService.deleteOption(this.queId, this.deleteOptionId).subscribe((data) => {
            if (data.success) {
              // this._snackBar.open(data.message, '', { duration: 1000, horizontalPosition: 'right', verticalPosition: 'top', panelClass: ['notification', 'success'] });
              this.notificationService.success(data.message);
            }
          },
          (error) => {
            this.webErrorService.handleAPIErrors(error);
          });
        }
        this.scoreArray = [];
        this.arrayForScoreadd.forEach((element) => {
          if (element.answerValid == true) {
            this.scoreArray.push(element.correctPoints);
          }
        });
        this.newEvent = this.scoreArray.reduce(add, 0);
        function add(accumulator, a) {
          return accumulator + a;
        }
        // this.notificationService.success("Option deleted successfully");
      }
    });
  }

  saveQuestion() {
    this.addOptionNew.forEach(element => {
      element.answerDescription['description'] = element.answerDescription['description'] //.replace(/(<([^>]+)>)/ig, '')
      element.answerDescription['description'] = element.answerDescription['description'] //.replace(/^\s+/g, '');
    });

    if (this.addOptionNew.length <= 1) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg2'), true, 'warn')
    } else {
      this.addnewquestion = new AddNewQuestion();
      this.addnewquestion.questiondescription = new QuestionDescription();

      let selectetionOptionValue = this.addOptionNew.filter(
        (value) => value.answerValid == true
      );

      let selectioIndex = this.addOptionNew.findIndex(
        (value) => value.answerValid == true
      );
      this.addnewquestion.itemId = this.itemBankQueId;
      this.questionhtml = this.addQuestionForm.controls['question'].value;
      this.questionhtml = this.questionhtml; //.replace(/(<([^>]+)>)/ig, '');
      let rmCharSpace = this.questionhtml //.replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();
      if (rmCharSpace.length === 0) {
        this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg3'), true, 'warn')
      }
      else if (selectioIndex < 0 && this.scoringTypeId == ScoringTypeEnum.OnQuestion) {
        this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg4'), true, 'warn')
      } else {
        if (this.editMode == true) {
          this.questionhtml = this.addQuestionForm.controls['question'].value;
          this.allowChwckAnsSelectValue = JSON.parse(
            this.userForm.controls['allowCheckAnswer'].value
          );
          this.addnewquestion.allowCheckAnswer = this.allowChwckAnsSelectValue;

          this.scoringTypeExactMatchValue = JSON.parse(
            this.userForm.controls['scoringTypeMatch'].value
          );
          this.addnewquestion.scoringTypeExactMatch =
            this.scoringTypeExactMatchValue;

          this.addnewquestion.autoScoring = this.userForm.controls['autoscore'].value;
          this.shuffleSelectValue = this.userForm.controls['shuffle'].value;
          this.addnewquestion.shuffleOption = this.shuffleSelectValue;
          this.fetchEditOption.forEach((element) => {
            element.modified = true;
          });
          this.addnewquestion.options = this.fetchEditOption;
        } else {
          this.questionhtml = this.addQuestionForm.controls['question'].value;
          this.autoscoreSelectValue = JSON.parse(
            this.userForm.controls['autoscore'].value
          );
          this.addnewquestion.autoScoring = this.autoscoreSelectValue;

          this.shuffleSelectValue = this.userForm.controls['shuffle'].value;
          this.addnewquestion.shuffleOption = this.shuffleSelectValue;

          this.addnewquestion.options = this.addOptionNew;
        }
        this.addnewquestion.correctPoints = this.newEvent;

        if (this.QuestionImages.length > 0) {
          this.QuestionImages.forEach(ele => {

            rmCharSpace = rmCharSpace.replace(ele.base64, ele.uniqueId)

            let startIndex = ele.base64.lastIndexOf('base64,');
            ele.base64 = ele.base64.substring(startIndex +7)
          })
        }
        this.addnewquestion.questiondescription.description = rmCharSpace;
        this.addnewquestion.questionImages = this.QuestionImages;

        if (this.optionImages.length > 0) {
          this.optionImages.forEach(ele => {
            this.addnewquestion.options.forEach(option => {
              option.answerDescription.description = option.answerDescription.description.replace(ele.base64, ele.uniqueId)
            })
            let startIndex = ele.base64.lastIndexOf('base64,');
            ele.base64 = ele.base64.substring(startIndex +7)
          })
        }

        this.addnewquestion.optionImages = this.optionImages;

        this.addnewquestion.questiondescription.description = rmCharSpace;
        this.addnewquestion.active = true;
        this.addnewquestion.ansRenderCount = 0;

        this.addnewquestion.questiondescription.mediaURL = ['String'];
        this.addnewquestion.questiondescription.file_name = this.uploadedFileNames;
        this.addnewquestion.questionOrder = 0;
        this.addnewquestion.questionSubTypeId = QuestionSubTypeIdEnum.MultipleChoiceOptions;
        this.addnewquestion.questionTypeId = QuestionTypeIdEnum.MultipleChoiceOptions;
        if (this.userForm.controls['allowCheckAnswer'].value) {
          this.allowChwckAnsSelectValue = JSON.parse(
            this.userForm.controls['allowCheckAnswer'].value
          );
          this.addnewquestion.allowCheckAnswer = this.allowChwckAnsSelectValue;
        }
        if (this.userForm.controls['scoringTypeMatch'].value) {
          this.scoringTypeExactMatchValue = JSON.parse(
            this.userForm.controls['scoringTypeMatch'].value
          );
          this.addnewquestion.scoringTypeExactMatch =
            this.scoringTypeExactMatchValue;
        }
        if (this.userForm.controls['questionDisplay'].value) {
          this.questionDisplayValue = this.userForm.controls['questionDisplay'].value
          this.addnewquestion.questiondisplayoptions = this.questionDisplayValue;
        }
        this.miniscoretype =
          this.userForm.controls['minimumScoreIfAttempt'].value;
        this.miniscoretypeMainvalue = +this.miniscoretype;
        this.addnewquestion.minScoreIfAttempt = this.miniscoretypeMainvalue;
        this.penaltypointselectvalue =
          this.userForm.controls['penaltyPoint'].value;
        this.penaltypointMainvalue = +this.penaltypointselectvalue;
        this.addnewquestion.penaltyPoints = this.penaltypointMainvalue;

        if (this.scoringTypeId == ScoringTypeEnum.OnOption) {
          this.addnewquestion.questionSubTypeId = QuestionSubTypeIdEnum.scoringType_MultipleChoiceOptions;
          this.addnewquestion.questionTypeId = QuestionTypeIdEnum.multichoice_score_option;

          // for (let o of this.addnewquestion.options) {
          //   if (o.correctPoints === 0) {
          //     this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg5'), true, 'warn') // Used to display alert message
          //     return;
          //   }
          // }
        }

        if (this.scoringTypeId == ScoringTypeEnum.On180360Degree) {
          let valueArr = this.addnewquestion.options.map(function(item){ return item['styleid'] });

          if (!(valueArr.includes(0) || valueArr.includes(undefined))) {
            let isDuplicate = valueArr.some(function(item, idx){
              return valueArr.indexOf(item) != idx
            });

            if (isDuplicate) {
              this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg6'), true, 'warn') // Used to display alert message
              return;
            }
          } else {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg7'), true, 'warn') // Used to display alert message
            return;
          }

          this.addnewquestion.questionSubTypeId = QuestionSubTypeIdEnum.style_MultipleChoiceOptions;
          this.addnewquestion.questionTypeId = QuestionTypeIdEnum.styleType_options;
        }

        if (this.editMode == false) {
          if (this.questionhtml == '<p></p>') {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg3'), true, 'warn')
          } else {
            if (this.itemId) {
              this.questionService
                .addQuestion(this.addnewquestion, this.itemId)
                .subscribe(
                  (resData) => {
                    this.saveDisable = true;
                    // this._snackBar.open(resData?.message, '', { duration: 1000, horizontalPosition: 'right', verticalPosition: 'top', panelClass: ['notification', 'success'] });
                    this.notificationService.success(resData?.message); // This line used to display message
                    // this.itemservice.questionCountUpdate.next(true);
                    // this.questionService.reloadList.next(true);
                    this.listDisplay = true;

                    // this.back();
                  },
                  (error) => {
                    this.webErrorService.handleAPIErrors(error, null, true, 'warn');
                  });
            }
          }
        }

        // for Edit Quetion
        if (this.editMode == true) {
          if (this.questionhtml == '<p></p>') {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg3'), true, 'warn')
          } else {
            // this.questionService.deleteOption(this.queId, this.deleteOptionId).subscribe((data) => { });
            this.questionService
              .updateQuestion(this.addnewquestion, this.itemId, this.queId)
              .subscribe(
                (resData) => {
                  this.itemservice.editedGetItem(resData.data);
                  // this._snackBar.open(resData?.message, '', { duration: 0, horizontalPosition: 'right', verticalPosition: 'top', panelClass: ['notification', 'success'] });
                  this.notificationService.success(resData?.message); // This line used to display message
                  // this.itemservice.questionCountUpdate.next(true);
                  // this.questionService.reloadList.next(true);
                  this.listDisplay = true;

                  // this.back();
                },
                (error) => {
                  this.webErrorService.handleAPIErrors(error, null, true, 'warn');
                });
          }
        }
      }
    }
  }

  clickData() {
    this.set_main_form = true;
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  ngOnDestroy(): void {
    if (sessionStorage.getItem('questionuuId')) {
      this.queId = sessionStorage.removeItem('questionuuId');
      sessionStorage.removeItem('questionId');
      sessionStorage.removeItem('questionuuId');
    }
  }

  changeFromChild(): void {
    this.parentData = +1;
  }

  data: any;

  openDynamic(index: any) {
    this.data = index;
    if (this.data == index) {
      this.openedD = true;
    } else {
      this.openedD = false;
    }
  }

  back() {
    this.postCreated.emit('false');
    this.display = true;
    // this.editor.destroy();
  }

  openDialog(optionData: any, optionId: number, index): void {
    const dialogSubscription = this.dialog.open(ItemsSubPartEditorComponent,
      { width: '950px', height: '350px', panelClass: 'option-dialog', data: { value: optionData } })
      .afterClosed().subscribe((result) => {
        if (result) {
          var optionUpdateText = new OptionUpdateText();
          optionUpdateText.oldValue = optionData;
          optionUpdateText.newValue = result;
          optionUpdateText.optionIdDia = optionId;
          this.questionService.getUpdateEditValue(optionUpdateText);
        }
        this.itemservice.getfileName.subscribe(file=>{
          this.addOptionNew[index].answerDescription.file_name = file;
        })
        dialogSubscription.unsubscribe();
      });
  }

  dragAndDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.addOptionNew, event.previousIndex, event.currentIndex);
    this.saveOderApiCall(this.addOptionNew);
  }

  drop1(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.fetchEditOption, event.previousIndex, event.currentIndex);
    this.saveOderApiCall(this.fetchEditOption);
  }

  saveOderApiCall(data) {
    let payload = [];
    data.forEach((e, index) => {
      let que = {
        "optionid": e.optionId,
        "arrangeorder": index + 1
      };

      e.arrangeOrder = index + 1;
      payload.push(que);
    });

    this.fetchEditOption = data;
    this.addOptionNew = data;

    this.itemservice.arrangeOrderForOptions(this.questionuuuid, payload).subscribe((data) => {
    },
    (error) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }
}
export class OptionUpdateText {
  oldValue: any;
  newValue: any;
  optionIdDia: any;
}
